import React, {Component} from 'react'
import PropTypes from "prop-types"
import {Alert, Button, FormCheck as Checkbox, Col, FormLabel as ControlLabel, Form, FormControl, FormGroup, Modal, Row} from 'react-bootstrap'

import * as Acl from "../utils/acl"


const defaultChangePassword = {
	email: "",
	password: "",
	password2: "",
	errorSeen: false,
	submitted: false
};

const isValidPassword = (password) => {
	return password && password.length >= 5 && password.search(/[!#$%&? "'_\-@^*]/) >= 0
};

class Login extends Component {

	constructor(props) {
		super(props);

		this.state = {
			tab: "login",
			forgottenPassword: false,
			login: {
				email: "",
				password: "",
				rememberMe: 1,
				errorSeen: false
			},
			isChangePasswordModalOpen: false,
			changePassword: Object.assign({}, defaultChangePassword)
		};

		this.handleLoginInputChange = this.handleLoginInputChange.bind(this);
		this.handleLoginSubmit = this.handleLoginSubmit.bind(this);
		this.handleForgottenPasswordSubmit = this.handleForgottenPasswordSubmit.bind(this);

		this.handleChangePasswordInputChange = this.handleChangePasswordInputChange.bind(this);
		this.handleChangePasswordSubmit = this.handleChangePasswordSubmit.bind(this);

		this.renderAlert = this.renderAlert.bind(this);
	}

	componentDidUpdate(prevProps) {
		const {session, token} = this.props;
		const {isChangePasswordModalOpen} = this.state;

		if (Acl.isLoggedIn(session)) {
			// successful login, close modal
			this.setState({isLoginModalOpen: false});
			return
		}

		if (!isChangePasswordModalOpen && !Acl.isLoggedIn(session) && token) {
			this.setState({isChangePasswordModalOpen: true});
			return
		}
	}

	handleLoginInputChange(e) {
		const target = e.target || e;
		let value = target.value;
		const name = target.id;

		const {login} = this.state;
		if (target.type === 'checkbox' && !target.checked) {
			login[name] = 0
		} else {
			login[name] = target.type === 'checkbox' ? 1 : value
		}
		this.setState({login: login})
	}

	handleForgottenPasswordSubmit(e) {
		if (e) {
			e.preventDefault()
		}

		const {login} = this.state;
		login.errorSeen = false;
		this.setState({login: login});
		this.props.onForgottenPassword(login.email).then((json) => {
			if (json && json.response && json.response.result === 'OK') {
				this.handleLoginModalDismissClick()
			}
		})
	}

	handleLoginSubmit(e) {
		if (e) {
			e.preventDefault()
		}

		const {login} = this.state;
		login.errorSeen = false;
		this.setState({login: login});
		this.props.onLogin(login.email, login.password, login.rememberMe)
	}

	getPasswordValidationState() {
		const p = this.state.changePassword.password;
		if (!p && !this.state.changePassword.submitted) {
			return null
		}
		if (!isValidPassword(p)) {
			if (!this.state.changePassword.submitted) return 'warning';
			return 'error'
		}
		return 'success'
	}

	getPassword2ValidationState() {
		const p = this.state.changePassword.password;
		const p2 = this.state.changePassword.password2;
		if (!this.state.changePassword.submitted) {
			return null
		}
		if (p && p === p2) return 'success';
		return 'error'
	}

	handleChangePasswordInputChange(e) {
		const target = e.target || e;
		let value = target.value;
		const name = target.name;

		const {changePassword} = this.state;
		changePassword[name] = value;
		this.setState({changePassword: changePassword})
	}

	handleChangePasswordSubmit(e) {
		if (e) {
			e.preventDefault()
		}

		const {changePassword} = this.state;
		changePassword.submitted = true;
		let valid = true;
		if (changePassword.password !== changePassword.password2) {
			valid = false
		} else if (!isValidPassword(changePassword.password)) {
			valid = false
		}

		changePassword.errorSeen = false;
		this.setState({changePassword: changePassword});
		if (!valid) {
			return
		}

		this.props.onChangePassword(changePassword.email, changePassword.password, this.props.token).then((json) => {
			if (json && json.response && json.response.result === 'OK') {
				this.setState({changePassword: Object.assign({}, defaultChangePassword)});
				this.handleChangePasswordModalDismissClick();
				if (this.props.token) {
					this.props.history('/')
				}
			}
		})
	}

	renderAlert(error) {
		const {t} = this.props;

		return <Alert variant="danger">
			<h4>Chyba</h4>
			<p>{t(error)}</p>
		</Alert>
	}

	renderLogin() {
		const {login, forgottenPassword} = this.state;
		const {session} = this.props;

		return (
			<div id={"login-tab"}>
				<h2>{forgottenPassword ? 'Zapomenuté heslo' : 'Přihlášení'}</h2>
				<Form horizontal onSubmit={forgottenPassword ? this.handleForgottenPasswordSubmit : this.handleLoginSubmit}>

					<div>
						{session.error && !login.errorSeen && this.renderAlert(session.error)}
						{forgottenPassword && <p>bla bla</p>}
						<FormGroup controlId="email">
							<Col componentClass={ControlLabel} sm={3}>
								Email
							</Col>
							<Col sm={7}>
								<FormControl type="email" name="email" value={login.email} onChange={this.handleLoginInputChange}/>
							</Col>
						</FormGroup>

						{!forgottenPassword && <FormGroup controlId="password">
							<Col componentClass={ControlLabel} sm={3}>
								Heslo
							</Col>
							<Col sm={7}>
								<FormControl type="password" name="password" value={login.password} onChange={this.handleLoginInputChange}/>
							</Col>
						</FormGroup>}

						{!forgottenPassword && <FormGroup>
							<Col smOffset={3} sm={7}>
								<Checkbox id="rememberMe" name="rememberMe" checked={login.rememberMe} onChange={this.handleLoginInputChange}>Zapoamatuj si mě</Checkbox>
							</Col>
						</FormGroup>}
					</div>

					<div className={"padded-buttons"}>
						{!forgottenPassword && <Row>
							<Col sm={6} className="text-left">
								<Button variant="link" onClick={() => {
									const {login} = this.state;
									login.errorSeen = true;
									this.setState({forgottenPassword: true, login})
								}}>Zapomenuté heslo</Button>
							</Col>
							<Col sm={6} className="text-right">
								<Button type="submit" onClick={this.handleLoginSubmit} variant="success"><span className="fa fa-lock"/> Přihlásit se<span className="fa fa-chevron-right"/></Button>
							</Col>
						</Row>}
						{forgottenPassword && <Row>
							<Col sm={6} className="text-left">
								<Button onClick={() => {
									const {login} = this.state;
									login.errorSeen = true;
									this.setState({forgottenPassword: false, login})
								}}>Storno</Button>
							</Col>
							<Col sm={6} className="text-right">
								<Button type="submit" onClick={this.handleForgottenPasswordSubmit} variant="success"><span className="fa fa-envelope"/> Obnovit heslo</Button>
							</Col>
						</Row>}
					</div>
				</Form>
			</div>
		)
	}

	renderChangePasswordModal() {
		const {isChangePasswordModalOpen, changePassword} = this.state;
		const {session, token} = this.props;

		if (!isChangePasswordModalOpen) {
			return null
		}

		return (
			<Modal onHide={this.handleChangePasswordModalDismissClick} show={true}>
				<Form horizontal onSubmit={this.handleChangePasswordSubmit}>
					<Modal.Login>
						<Modal.Title>{token ? "Vytvoření nebo obnova hesla" : "Změna hesla"}</Modal.Title>
					</Modal.Login>

					<Modal.Body>
						<p>Heslo musí být alespoň 5 znaků dlouhé a obsahovat speciální znak (!#$%&?_-@^*).</p>
						{session.error && !changePassword.errorSeen && this.renderAlert(session.error)}
						{!Acl.isLoggedIn(session) && <FormGroup controlId="email">
							<Col componentClass={ControlLabel} sm={3}>
								Email
							</Col>
							<Col sm={7}>
								<FormControl type="email" name="email" value={changePassword.email} onChange={this.handleChangePasswordInputChange}/>
							</Col>
						</FormGroup>}

						<FormGroup controlId="password" validationState={this.getPasswordValidationState()}>
							<Col componentClass={ControlLabel} sm={3}>
								Nové heslo
							</Col>
							<Col sm={7}>
								<FormControl type="password" name="password" value={changePassword.password} onChange={this.handleChangePasswordInputChange}/>
							</Col>
						</FormGroup>

						<FormGroup controlId="password2" validationState={this.getPassword2ValidationState()}>
							<Col componentClass={ControlLabel} sm={3}>
								Kontrola hesla
							</Col>
							<Col sm={7}>
								<FormControl type="password" name="password2" value={changePassword.password2} onChange={this.handleChangePasswordInputChange}/>
							</Col>
						</FormGroup>
					</Modal.Body>

					<Modal.Footer>
						<Row>
							<Col sm={12}>
								<Button onClick={this.handleChangePasswordModalDismissClick}>Storno</Button>
								<Button type="submit" onClick={this.handleChangePasswordSubmit} variant="success"><span className="fa fa-ok"/> Změnit heslo</Button>
							</Col>
						</Row>
					</Modal.Footer>
				</Form>
			</Modal>
		)
	}

	render() {
		const {tab} = this.state;

		return (
			<div id="login-page">
				<Row>
					<Col md={6} mdOffset={2}>
						<Row>
							<Col md={10} mdOffset={1}>
								{tab === 'login' ? this.renderLogin() : null}
								{/*{this.renderChangePasswordModal()}*/}
							</Col>
						</Row>
					</Col>
				</Row>
			</div>
		)
	}
}

Login.propTypes = {
	onLogin: PropTypes.func.isRequired,
	onChangePassword: PropTypes.func.isRequired,
	onForgottenPassword: PropTypes.func.isRequired,
	session: PropTypes.object.isRequired,
	token: PropTypes.string
};

export default Login
